import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import PushNotificationTemplates from './PushNotificationTemplates';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {
  const title = intl?.formatMessage(messages.managePushNotificationTemplates);

  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/push-notification-templates', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><PushNotificationTemplates title={title} /></AdminLayout>,
  };
}
